
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface DebugDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  debugInfo: string | null;
}

const DebugDialog = ({ open, onOpenChange, debugInfo }: DebugDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Excel Upload Debug Information</DialogTitle>
          <DialogDescription>
            This information can help troubleshoot Excel upload issues
          </DialogDescription>
        </DialogHeader>
        <div className="bg-muted p-4 rounded-md">
          <pre className="whitespace-pre-wrap text-xs">
            {debugInfo || "No debug information available"}
          </pre>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DebugDialog;
